import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { EmptyDataGridMessage } from "./EmptyDatagridMessage";
import { EmptyDatagridMessageType } from "./IEmptyDataGridMessage";
/**
* Hláška, která se zobrazuje v situaci, kdy Datagrid stromu nemá žádné záznamy, které by zobrazil
*/
export class EmptyTreeDataGridMessage extends EmptyDataGridMessage {
    /**
     * Nastaví odpovídající hlášku u prázdného DataGridu
     * @param messageType Typ hlášky
     */
    protected override async _setMessageType(messageType: EmptyDatagridMessageType): Promise<void> {
        if (messageType === EmptyDatagridMessageType.initialEmpty) {
            this._resetIconState();

            this._iconElement.classList.add(this.emptyMessageCustomization.noItemsIcon || "InitialEmpty");

            Localization.addLocData(this._descElement, this.emptyMessageCustomization.noItemsLocKey || "GUI-676412"); // Žádné záznamy. V tomto stromu nemáme co zobrazit.

            return;
        }

        await super._setMessageType(messageType);
    }
}

registerCustomElement("tsc-EmptyTreeDataGridMessage", EmptyTreeDataGridMessage);
